export const sizeMap = {
  4: 'w-4 h-4',
  6: 'w-6 h-6',
  28: 'w-28 h-28'
};

export const borderMap = {
  2: 'border-2',
  4: 'border-4',
  8: 'border-8',
};

export const spinnerBaseMap = {
  white: 'border-r-white border-b-white border-l-white',
  personalized: 'border-r-personalized border-b-personalized border-l-personalized',
  font: 'border-r-font border-b-font border-l-font',
  'purple-200': 'border-r-purple-200 border-b-purple-200 border-l-purple-200',
  'gray-300': 'border-r-gray-300 border-b-gray-300 border-l-gray-300',
  'gray-100': 'border-r-gray-100 border-b-gray-100 border-l-gray-100',
  'blue-50': 'border-r-blue-50 border-b-blue-50 border-l-blue-50',
  transparent: 'border-r-transparent border-b-transparent border-l-transparent',
  'red-300': 'border-r-red-300 border-b-red-300 border-l-red-300',
  'red-600': 'border-r-red-600 border-b-red-600 border-l-red-600',
};

export const spinnerTopMap = {
  white: 'border-t-white',
  'purple-200': 'border-t-purple-200',
  'gray-300': 'border-t-gray-300',
  'gray-100': 'border-t-gray-100',
  'blue-50': 'border-t-blue-50',
  transparent: 'border-t-transparent',
  'red-300': 'border-t-red-300',
  'red-600': 'border-t-red-600',
  personalized: 'border-t-personalized',
  font: 'border-t-font',
};
